module.exports = __webpack_public_path__ + "images/questions/qa_title_8797ad721df31ef917e06c2ea78c1aa3.png";